import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import BaseLayout from "@/Layouts/BaseLayout";
import {Breadcrumbs} from '@mui/material';
import Link from "@/Layouts/Link";
import {isDesktop} from "@/Helpers/Function";
import '@/Pages/Philosophy/scss/index.scss';

class Philosophy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            videoSvg: true,
            philosophyVideoPauseFlag: true,
        };
        this.videoRef = React.createRef();
    }

    componentWillUnmount() {
        clearInterval(this.videoTimerId);
    }

    /**
     * Какой-то Timer
     * @returns {number}
     */
    videoTimer = () => setTimeout(() => {
        this.setState({philosophyVideoPauseFlag: false})
    }, 3000);

    /**
     * Воспроизведение - пауза видео
     */
    mediaChange = () => {
        try {
            const video = this.videoRef.current;
            if (video.paused) {
                video.play();
                this.setState({videoSvg: false})
            } else {
                video.pause();
                this.setState({videoSvg: true})
            }
            video.onended = (e) => {
                this.setState({videoSvg: true})
            };
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Убираем кнопку паузы на мобилке
     */
    mediaChangePlayPause = () => {
        try {
            if (!isDesktop()) {
                clearInterval(this.videoTimerId);
                if (!this.state.philosophyVideoPauseFlag) {
                    this.setState({philosophyVideoPauseFlag: true})
                }
                this.videoTimerId = this.videoTimer();
            }
        } catch (e) {
            console.log('e', e);
        }
    };

    render() {
        const {uploadUrl = ''} = this.props;
        const { videoSvg, philosophyVideoPauseFlag} = this.state;

        return <BaseLayout {...this.props}>
            <section className={`section`}>
                <div className={`breadcrumbs`}>
                    <div className={`container`}>
                        <Breadcrumbs maxItems={2} itemsAfterCollapse={2}>
                            <Link className="breadcrumbs__link" href={`/`}>
                                Главная
                            </Link>
                            <p className={`breadcrumbs__text`}>
                                Философия бренда
                            </p>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className={`container`}>
                    <h1 className={`h1`}>Философия бренда</h1>
                    <div className={`philosophy`}>
                        <div className={`philosophy__video`}>
                            <div className={`video-box`}>
                                <video id={`video`}
                                       ref={this.videoRef}
                                       width={`100%`}
                                       preload={`auto`}
                                       poster={`/storage/img/philosophy/philosophy_1330x600.jpg`}
                                >
                                    <source src={`${uploadUrl}/media/video/philosophy/platina_phil.mp4`}
                                            type="video/mp4" />
                                </video>
                            </div>
                            <div className={`video-control`}
                                 onClick={() => this.mediaChangePlayPause()}
                            >
                                {videoSvg ?
                                    <>
                                        <div className={`gg-play-button`}
                                             onClick={() => this.mediaChange()}></div>
                                    </>
                                    :
                                    <>
                                        {philosophyVideoPauseFlag && (
                                            <div className={`gg-pause-button`}
                                                 onClick={() => this.mediaChange()}></div>
                                        )}
                                    </>
                                }
                            </div>
                        </div>
                        <p className={`philosophy__item`}>
                            Наш путь начался очень и&nbsp;очень давно&nbsp;&mdash; миллионы и&nbsp;миллиарды лет
                            назад, когда создавалась наша Вселенная. Этот огромный, необъятный и&nbsp;прекрасный
                            мир даёт нам цель и&nbsp;созидает ценности, которые формируют нас. Каждое существо,
                            каждый объект в&nbsp;этом мире&nbsp;&mdash; есть захватывающий танец космических
                            частиц, прошедших сотни и&nbsp;сотни перерождений, проживших тысячи жизней. Каждый
                            из&nbsp;нас мог быть звездой, частицей или... волной, которая летит сквозь время
                            и&nbsp;пространство со&nbsp;скоростью света. Мог быть энергией, из&nbsp;которой
                            возникают звёзды и&nbsp;галактики! И&nbsp;у&nbsp;каждого
                            из&nbsp;нас&nbsp;&mdash; свой путь.
                        </p>
                        <p className={`philosophy__item`}>
                            Мы&nbsp;уникальны и&nbsp;неповторимы на&nbsp;этом пути, и&nbsp;в&nbsp;каждом
                            из&nbsp;нас скрыт тот самый исходный код, благодаря которому мы&nbsp;чувствуем
                            и&nbsp;можем считывать красоту и&nbsp;богатство мира вокруг нас. Благодаря которому
                            чувствуем, что мир&nbsp;&mdash; это нечто большее. Сама Вселенная словно&nbsp;бы
                            говорит нам&nbsp;&mdash; вы&nbsp;больше, глубже и&nbsp;многограннее.
                        </p>
                        <p className={`philosophy__item`}>
                            Драгоценные металлы&nbsp;&mdash; величайший дар Вселенной нам, людям. Они буквально
                            спустились к&nbsp;нам с&nbsp;неба: гигантские метеориты несли их&nbsp;на&nbsp;Землю
                            миллионы световых лет сквозь космическую пустоту... И&nbsp;кажется, что наша встреча
                            была частью большого замысла. Они&nbsp;&mdash; часть самого Космоса. Проводники
                            энергии Солнца, способные концентрировать в&nbsp;себе энергию и&nbsp;память своего
                            владельца. Их&nbsp;почитали жители Древнего Египта&nbsp;&mdash; чувствовали, что
                            драгоценности непосредственно связаны с&nbsp;миром природы. Забытые в&nbsp;веках
                            шумеры добывали&nbsp;их, чтобы спасти загадочную и&nbsp;мифическую планету Нибиру.
                            Наши предки, славяне делали из&nbsp;них украшения и&nbsp;амулеты, оберегавшие
                            их&nbsp;души. Драгоценные металлы&nbsp;&mdash; это универсальный проводник историй
                            и&nbsp;смыслов сквозь время. И&nbsp;это те&nbsp;ценности, которые нас объединяют.
                        </p>
                        <p className={`philosophy__item`}>
                            Наша миссия в&nbsp;том, чтобы через дизайн, через красоту ювелирных украшений
                            передать ту&nbsp;частицу космического и&nbsp;прекрасного, что хранят в&nbsp;себе
                            драгоценные металлы. Создавать такие изделия, которые помогают открывать внутренний
                            мир, обретать любовь и&nbsp;дарить её&nbsp;близким. Такие, что позволяют ощутить
                            свою ценность и&nbsp;значимость для Вселенной. Мы, ювелирный бренд PLATINA,
                            стремимся быть частью великой ювелирной истории, которая возникла сотни и&nbsp;даже
                            тысячи лет назад&nbsp;&mdash; когда наши предки впервые ощутили свою связь
                            с&nbsp;изделиями из&nbsp;драгоценных металлов. И&nbsp;мы&nbsp;хотим
                            продолжить&nbsp;её, развить, сделать лучше, богаче, интереснее. И&nbsp;это
                            та&nbsp;цель, к&nbsp;которой мы&nbsp;стремимся.
                        </p>
                        <p className={`philosophy__item`}>
                            Мы&nbsp;верим, что украшения из&nbsp;драгоценных металлов, украшения
                            из&nbsp;золота&nbsp;&mdash; есть олицетворение Космоса, воплощение бытия. Фрагменты
                            вечности, выхваченные из&nbsp;непрерывного течения времени, смысл
                            которых&nbsp;&mdash; сохранить и&nbsp;передать это знание. И&nbsp;мы, люди так
                            похожи на&nbsp;них! Мы&nbsp;тоже&nbsp;&mdash; путешественники во&nbsp;времени,
                            потомки великих эпох и&nbsp;наследники поколений. И&nbsp;это пробуждает в&nbsp;нас
                            желание выбирать, мечтать и&nbsp;носить украшения. Потому что это не&nbsp;даёт нам
                            забыть, кто мы&nbsp;есть на&nbsp;самом деле.
                        </p>
                    </div>
                </div>
            </section>
        </BaseLayout>
    }
}

export default useWithStore(Philosophy);


